import { AfterViewInit, Component, ElementRef, Input, OnInit, Output, Renderer2, ViewChild, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { EventEmitter } from '@angular/core';
import { DhlFormControl } from '../../models/dhl-form-control';
import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonConfig } from 'src/app/common/configuration/common.config';
import { APP_Constants } from 'src/app/app.constant';
import { Modal } from 'src/app/common/modal/modal';
import { ModalService } from 'src/app/common/modal/modal.service';
import { AppService } from 'src/app/app.service';
import { ErrorsConfig } from 'src/app/common/configuration/errors.config';
import {TranslateService} from '@ngx-translate/core';
import { Constant } from '../../../constants/constants';
import moment from 'moment';
import { ModalConfigData } from 'src/app/common/modalconfig/modalconfig';
import { AlphaService } from 'src/app/app-business-object-module/alpha.service';


@Component({
    selector: 'app-form-field-po-item-autocomplete-v2',
    templateUrl: './form-field-po-item-autocomplete-v2.component.html',
    styleUrls: ['./form-field-po-item-autocomplete-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class FormFieldAutoPoItemcompleteV2Component implements OnInit, AfterViewInit {

  @Input() configData: DhlFormControl;
  @Input() frmGroup: UntypedFormGroup;

  @Input() fieldMetadata;
  @Output() fieldAction = new EventEmitter();
  @Output() controlValue = new EventEmitter();

  @ViewChild('formControl',{static: true, read: ElementRef}) formControl: ElementRef;
  @ViewChild('inputEle',{static: true, read: ElementRef}) inputEle: ElementRef;

  placeholder: string = '';
  validationType: string = '';
  fieldType: string = '';
  fieldIcon: string = '';
  enum = Constant;

  pickerToggle: boolean = false;

  // seach-com code
  public suggestionList: any[];
  private searchTerms = new Subject<any>();
  suggestion: boolean;
  public selectedItems: Array<any>;
  typing = false;
  searchStr = "";
  selection: string;
  noItemFound: boolean = false;
  noItemFoundError; selectFromListError;
  // make api call vars
  progressBar = false;
  color: String = 'primary';
  mode: String = 'indeterminate';
  editField: boolean;
  isLoading: boolean;
  templateData: any;
  selfServiceConfig: boolean = false;
  orderForm: any;
  orderFormSubmitted;

  constructor(private _eref: ElementRef, private renderer: Renderer2, private modalService: ModalService, private appService: AppService, private translate: TranslateService, public alphaService: AlphaService) {
    this.suggestionList = [];
    this.suggestion = true;
  }

  ngOnInit() {

    if(this.configData.customFormFlag){
      this.selfServiceConfig = false;
    }
    else if(sessionStorage.getItem('isSelfServiceConfig'))
    {
      this.selfServiceConfig = true;
    }
    this.fieldType = this.fieldMetadata ? this.fieldMetadata.fieldType : 'search';
    this.fieldIcon = this.fieldMetadata ? this.fieldMetadata.fieldIcon : null;
    this.searchStr = this.frmGroup.get(this.configData.name).value;
    this.toggleDisable(this.configData['disabled']);
    if (this.configData.validation.length)
      this.fieldValueValidation(this.configData.validation);

    this.searchTerms.pipe(debounceTime(CommonConfig.ITEM_SEARCH_TIMEOUT))
      .subscribe(term => {
        this.makeapicall(term);
        console.log(term);
      });
    this.noItemFound = false;
    if(!this.frmGroup.get(this.configData.name)['itemArray'])
      this.frmGroup.get(this.configData.name)['itemArray'] = [];

    this.noItemFoundError = ErrorsConfig.autocomplete.notFound;
    this.selectFromListError = ErrorsConfig.autocomplete.selectFromList;
    if (this.configData['editable'] === false) {
      this.frmGroup.get(this.configData.name).disable();
    }
  }

  normalView() {
    throw new Error('Method not implemented.');
  }

  ngAfterViewInit() {
    this.placeholder = this.configData.placeHolder;
    let templtName = localStorage.getItem('templateName');
    if ( templtName === "orderViewEdit" || templtName === "releaseOrderViewEdit" || templtName === "releaseOrder") {
      // this.frmGroup.get(this.configData.name)['itemArray'].push(this.frmGroup.get(this.configData.name).value);
    }
    this.searchStr  = this.frmGroup.get(this.configData.name).value;
    if(this.frmGroup.get(this.configData.name).value){
      this.frmGroup.get(this.configData.name).updateValueAndValidity();
    }
  }

  fieldValueValidation(validations) {
    validations.forEach((validataion: string | any) => {
      let element = (typeof validataion == "object" ? validataion.name : validataion);
      if (element === 'hidden') {
        if (!(this.frmGroup.get(this.configData.name)['hidden'] === false)) {
          this.frmGroup.get(this.configData.name)['hidden'] = true;
          this.configData.required = false;
          this.frmGroup.get(this.configData.name).clearValidators();
          this.frmGroup.get(this.configData.name).updateValueAndValidity();
        }
      }
    }, this);
  }

  toggleDisable(disabled) {
    if (disabled === true) {
      this.frmGroup.get(this.configData.name).disable();
      this.formControl.nativeElement.parentElement.classList.add('disabled');
    } else {
      this.frmGroup.get(this.configData.name).enable();
      this.formControl.nativeElement.parentElement.classList.remove('disabled');
    }
  }

  popFieldAction(e) {
    this.fieldAction.emit(e);
  }
  @HostListener('document:keyup', ['$event'])
  @HostListener('document:keyup.Tab', ['$event'])
  @HostListener('document:click', ['$event'])
  onWindowClick(event) {
    if (!this._eref.nativeElement.contains(event.target)) {
      this.typing = false;
      let selection: any = this.frmGroup.get(this.configData.name).value;
      if (selection !== '') {
        if (this.frmGroup.get(this.configData.name)['itemArray'] && this.frmGroup.get(this.configData.name)['itemArray'].indexOf(selection) < 0) {
          this.frmGroup.get(this.configData.name).setErrors({ 'selectFromList': true });
        }
      }
    }
  }

  controlValueChange(e) {
    // this.controlValue.emit(e);
    console.log('change---->', e.target.value.trim())
    // this.frmGroup.get(this.configData.name).setValue(e.target.value.trim());
  }

  setOnFocus($event) {
    if ($event.target.value.trim().length >= 3) {
      this.typing = true;
    }
  }

  onkeyupHandler($event) {
    console.log('affeted column on keyup');
    // if ($event.target.value.trim().length >= 3) {
    if ($event.currentTarget.value === '' && localStorage.getItem('templateName') === 'releaseOrder') {
      let index = this.frmGroup.parent.value.indexOf(this.frmGroup.value);
      let totalPoLine = this.frmGroup.parent.value.length;

      this.frmGroup.get(this.configData.name + "Id1").setValue('');
      this.frmGroup.get(this.configData.name + "Id2").setValue('');
      this.frmGroup.get(this.configData.name + "Id3").setValue('');
      this.frmGroup.get(this.configData['affectedColumns'][2]).setValue("");
      if(this.configData['affectedColumns'][3]) {
        this.frmGroup.get(this.configData['affectedColumns'][3]).setValue("");
      }
      if(this.configData['affectedColumns'][4]) {
        this.frmGroup.get(this.configData['affectedColumns'][4]).setValue("");
      }

      if (totalPoLine === 1) {
        localStorage.removeItem('poSourceId');
        localStorage.removeItem('poDestId');
        this.frmGroup.parent.parent.get(this.configData['affectedColumns'][0]).setValue("");
        this.frmGroup.parent.parent.get(this.configData['affectedColumns'][0])['secondaryText'] = '';
        this.frmGroup.parent.parent.get(this.configData['affectedColumns'][1]).setValue("");
        this.frmGroup.parent.parent.get(this.configData['affectedColumns'][1])['secondaryText'] = '';
      }
      else if (totalPoLine > 1) {
        let count = 0;
        this.frmGroup.parent.value.forEach((line, idx) => {
          if (line.poLineItemId1) {
            count++;
          }
        })
        if (count == 0) {
          localStorage.removeItem('poSourceId');
          localStorage.removeItem('poDestId');
          this.frmGroup.parent.parent.get(this.configData['affectedColumns'][0]).setValue("");
          this.frmGroup.parent.parent.get(this.configData['affectedColumns'][0])['secondaryText'] = '';
          this.frmGroup.parent.parent.get(this.configData['affectedColumns'][1]).setValue("");
          this.frmGroup.parent.parent.get(this.configData['affectedColumns'][1])['secondaryText'] = '';
        }
      }
    }

    if (this.frmGroup.get(this.configData.name).value !== '') {
      if (this.frmGroup.get(this.configData.name)['itemArray'] && this.frmGroup.get(this.configData.name)['itemArray'].indexOf(this.frmGroup.get(this.configData.name).value) > -1 ||
        (this.suggestionList.length > 0 && this.selection === this.frmGroup.get(this.configData.name).value)) {
        return;
      } else {
        this.selection = this.frmGroup.get(this.configData.name).value;
      }
    }

    this.frmGroup['tempControlIcon'] = false
    this.frmGroup['hazmatIcon'] = false;
    this.noItemFound = false;
    this.frmGroup['secondaryText'] = '';
    this.configData.hintText = '';
    let searchText = $event.currentTarget.value;
    if (searchText.length > 2 && searchText != null) {
      this.suggestionList = [];
      console.log(this.frmGroup.get(this.configData.name).errors)
      this.searchTerms.next(searchText);
      this.typing = true;
    } else {
      this.typing = false;
      this.suggestionList = [];
      this.frmGroup.get(this.configData.name)['itemArray'] = [];
    }
  }

  selectItem($event, data, disabled) {
    if(disabled){
      return
    }
    this.noItemFound = false;
    // icons
    if (data.tempControl) {
      this.frmGroup['tempControlIcon'] = true;
    }
    if (data.hazmat) {
      this.frmGroup['hazmatIcon'] = true;
    }

    // po line item secondary text
    if (this.configData['secondaryText']) {
      this.configData.hintText = 'true';
      let poLineSecondaryText = {
        'source': '',
        'seperator': 'arrow_right_alt',
        'destination': ''
      };
      poLineSecondaryText.source = data[this.configData['secondaryText'][0]] + ',' + data[this.configData['secondaryText'][1]] || '';
      poLineSecondaryText.destination = data[this.configData['secondaryText'][2]] + ',' + data[this.configData['secondaryText'][3]] || '';

      this.frmGroup['secondaryText'] = poLineSecondaryText;
    }
    // else {
    //   // line item secondary text
    //   if (data.nmfcarticle !== undefined && data.nmfcclass !== undefined) {
    //     if (data.nmfcarticle !== '' || data.nmfcclass !== '') {
    //       if (data.nmfcarticle !== '') {
    //         this.frmGroup['secondaryText'] = 'Article: ' + data.nmfcarticle;
    //       }
    //       if (data.nmfcclass !== '') {
    //         this.frmGroup['secondaryText'] = this.frmGroup['secondaryText'] + (data.nmfcarticle !== '' ? ', ' : '') + 'Class: ' + data.nmfcclass;
    //       }
    //     }
    //   }
    // }

    if (this.configData['affectedColumns']) {
      let source = data.OBLINE_SHIPFROM_ID + ' - ' + data.OBLINE_SHIPFROM_NAME;
      let destination = data.OBLINE_SHIPTO_ID + ' - ' + data.OBLINE_SHIPTO_NAME;
      let availableCount = data.AVAILABLE_COUNT;
      let itemDesc = data.ITEM_DESCRIPTION;
      let itemID = data.ITEM_XID;

      let affectedColumnNames = this.configData['affectedColumns'];
      if ('key' in affectedColumnNames[0]) {
        affectedColumnNames = this.configData['affectedColumns'][0].value;
      }
      if (Array.isArray(this.frmGroup.parent.controls)) {
        let sourceSecondary = data.OBLINE_SHIPFROM_ADDRESS_LINE_1 + "," + data.OBLINE_SHIPFROM_CITY + ',' + data.OBLINE_SHIPFROM_PROVINCECODE + ',' + data.OBLINE_SHIPFROM_POSTALCODE;
        let destSecondary = data.OBLINE_SHIPTO_ADDRESS_LINE_1 + "," + data.OBLINE_SHIPTO_CITY + ',' + data.OBLINE_SHIPTO_PROVINCECODE + ',' + data.OBLINE_SHIPTO_POSTALCODE;

        if (this.frmGroup.parent.parent.get(affectedColumnNames[0]).value == '' || this.frmGroup.parent.parent.get(affectedColumnNames[0]).value == null) {
          this.frmGroup.parent.parent.get(affectedColumnNames[0]).setValue(source);
          this.frmGroup.parent.parent.get(affectedColumnNames[0])['secondaryText'] = sourceSecondary;
          this.frmGroup.parent.parent.get(affectedColumnNames[0] + 'Id').setValue(data.OBLINE_SHIPFROM_ID);
          this.frmGroup.parent.parent.get(affectedColumnNames[0])['itemArray']=[source];
          let originMapUrl = "https://wego.here.com/directions/mix/" + data.OBLINE_SHIPFROM_ADDRESS_LINE_1 + "," + data.OBLINE_SHIPFROM_CITY + ',' + data.OBLINE_SHIPFROM_PROVINCECODE + ',' + data.OBLINE_SHIPFROM_POSTALCODE + ',' + data.OBLINE_SHIPFROM_COUNTRY + '?map=' + data.OBLINE_SHIPFROM_LAT + ',' + data.OBLINE_SHIPFROM_LON + ',15,normal';
          localStorage.setItem('originMapUrl', originMapUrl);
        }

        if (this.frmGroup.parent.parent.get(affectedColumnNames[1]).value == '' || this.frmGroup.parent.parent.get(affectedColumnNames[1]).value == null) {
          let destMapUrl = "https://wego.here.com/directions/mix/" + data.OBLINE_SHIPTO_ADDRESS_LINE_1 + "," + data.OBLINE_SHIPTO_CITY + ',' + data.OBLINE_SHIPTO_PROVINCECODE + ',' + data.OBLINE_SHIPTO_POSTALCODE + ',' + data.OBLINE_SHIPTO_COUNTRY + '?map=' + data.OBLINE_SHIPTO_LAT + ',' + data.OBLINE_SHIPTO_LON + ',15,normal';
          localStorage.setItem('destMapUrl', destMapUrl);

          this.frmGroup.parent.parent.get(affectedColumnNames[1]).setValue(destination);
          this.frmGroup.parent.parent.get(affectedColumnNames[1])['secondaryText'] = destSecondary;
          this.frmGroup.parent.parent.get(affectedColumnNames[1] + 'Id').setValue(data.OBLINE_SHIPTO_ID);
          this.frmGroup.parent.parent.get(affectedColumnNames[1])['itemArray']=[destination];
        }
        // this.appService.setUsedLocation(data);

        this.frmGroup.get(affectedColumnNames[2]).setValue(availableCount);
        if(affectedColumnNames[3] && itemID) {
          this.frmGroup.get(affectedColumnNames[3]).setValue(itemID);
        }
        if(affectedColumnNames[4] && itemDesc) {
          this.frmGroup.get(affectedColumnNames[4]).setValue(itemDesc);
        }
      } else {
        this.frmGroup.get(affectedColumnNames[0]).setValue(source);
        this.frmGroup.get(affectedColumnNames[1]).setValue(destination);
        this.frmGroup.get(affectedColumnNames[2]).setValue(availableCount);
        if(affectedColumnNames[3] && itemID) {
          this.frmGroup.get(affectedColumnNames[3]).setValue(itemID);
        }
        if(affectedColumnNames[4] && itemDesc) {
          this.frmGroup.get(affectedColumnNames[4]).setValue(itemDesc);
        }
      }
    }
    else if (this.configData.hasOwnProperty("affectedColumnsV2") && this.configData.affectedColumnsV2.length > 0) {
      let affectedColumnsArrOfObj =  this.configData.affectedColumnsV2
      affectedColumnsArrOfObj.forEach(columnsObj => {
        ////Start Loop for get data and manupulation uisng OTM config name and fill input feilds
        if (columnsObj.hasOwnProperty("configNameOTM")) {
          let fieldSetVal = '';
          columnsObj.configNameOTM.forEach(a => {
            if (data.hasOwnProperty(a)) fieldSetVal += (data[a] && fieldSetVal.length > 0) ? ' - ' + data[a] : data[a];
          });

          //Set value into input feilds
          if (fieldSetVal != 'undefined' && fieldSetVal != 'null' && fieldSetVal != undefined && fieldSetVal != null){
            if (this.frmGroup.get(columnsObj.configName)) {
              this.frmGroup.get(columnsObj.configName).setValue(fieldSetVal);
            } else if (this.frmGroup.parent.parent.get(columnsObj.configName)) {
              this.frmGroup.parent.parent.get(columnsObj.configName).setValue(fieldSetVal);
              /* if(columnsObj?.configName === "inco_term_id" || columnsObj?.configName === "inco_term_location" ){
                if (data.OBLINE_SHIPFROM_COUNTRY === data.OBLINE_SHIPTO_COUNTRY) {
                  if (columnsObj?.configName === "inco_term_id") {
                    let INCO_TERM_ID = data.INCO_TERM_ID ? data?.INCO_TERM_ID :'FOB'
                    this.frmGroup.parent.parent.get(columnsObj.configName).setValue(INCO_TERM_ID);
                  } else if (columnsObj?.configName === "inco_term_location") {
                    this.frmGroup.parent.parent.get(columnsObj.configName).setValue(data.OBLINE_SHIPFROM_CITY);
                  }
                  this.frmGroup.parent.parent.get(columnsObj.configName).enable();
                }else if (this.frmGroup.parent.parent.get(columnsObj.configName).value) {
                this.frmGroup.parent.parent.get(columnsObj.configName).disable();
               }
              } */
            } else if (this.frmGroup.parent.get(columnsObj.configName)) {
              this.frmGroup.parent.get(columnsObj.configName).setValue(fieldSetVal);
            };
            //Alpha-Location save for PO Release when Draft order enable
            let isDraftOrder : any = JSON.parse(localStorage.getItem("menuPages"));
            let templateName = localStorage.getItem('templateName')
            if (isDraftOrder && isDraftOrder.indexOf("DRAFT_ORDER") > -1 && (templateName === 'releaseOrderWithStatus' || templateName == 'releaseOrder')) {
              this.locationDateSave(data, columnsObj.configName);
            }
            //End
          }
        };
        //End

        ////Start Loop for get data and manupulation uisng secondary Text array
        if (columnsObj.hasOwnProperty("secondaryText")) {
          let sourceSecondary = '';
          columnsObj.secondaryText.forEach(b => {
            if (data.hasOwnProperty(b)) sourceSecondary += (data[b]  && sourceSecondary.length > 0) ? ',' + data[b] : data[b];
          });


          //Set value into input feilds
          if (sourceSecondary != 'undefined' && sourceSecondary != 'null' && sourceSecondary != undefined && sourceSecondary != null)
            if (this.frmGroup.get(columnsObj.configName)) {
              this.frmGroup.get(columnsObj.configName)['secondaryText'] = sourceSecondary;
            } else if (this.frmGroup.parent.parent.get(columnsObj.configName)) {
              this.frmGroup.parent.parent.get(columnsObj.configName)['secondaryText'] = sourceSecondary;
            } else if (this.frmGroup.parent.get(columnsObj.configName)) {
              this.frmGroup.parent.get(columnsObj.configName)['secondaryText'] = sourceSecondary;
            };
        };
        ////End

        ////Start Loop for set item array
        if (columnsObj.hasOwnProperty("itemArray")) {
          let sourceArray = '';
          columnsObj.itemArray.forEach(c => {
            if (data.hasOwnProperty(c)) sourceArray += (data[c] && sourceArray.length > 0) ? ' - ' + data[c] : data[c];
          });
          //Set key/value into obj
          if (sourceArray != 'undefined' && sourceArray != 'null' && sourceArray != undefined && sourceArray != null)
            if (this.frmGroup.get(columnsObj.configName)) {
              this.frmGroup.get(columnsObj.configName)['itemArray'] = [sourceArray];
            } else if (this.frmGroup.parent.parent.get(columnsObj.configName)) {
              this.frmGroup.parent.parent.get(columnsObj.configName)['itemArray'] = [sourceArray];
            } else if (this.frmGroup.parent.get(columnsObj.configName)) {
              this.frmGroup.parent.get(columnsObj.configName)['itemArray'] = [sourceArray];
            };
        };
        ////End

        //Set map URL for set into local storage
        if(columnsObj.hasOwnProperty("mapDetails")){
          let mapDetails = columnsObj.mapDetails
          let originMapUrl = mapDetails.fixURL;
          let dynPathData = '';
          mapDetails.dynPathname.forEach(d => {
            if (data.hasOwnProperty(d)) dynPathData += (data[d]  && dynPathData.length > 0) ? ',' + data[d] : data[d];

          });
          originMapUrl += dynPathData;
          mapDetails.dynSearch.forEach(Search => {
            originMapUrl += Search.queryParamKey;
            Search.queryParamValues.forEach(e => {
              let dynSearchData = '';
              if(Array.isArray(e)){
                e.forEach(f => {
                  if (data.hasOwnProperty(f)) dynSearchData += (data[f]  && dynSearchData.length > 0) ? ',' + data[f] : data[f];
                });
              } else {
                dynSearchData += e;
              }
              originMapUrl += dynSearchData;
            });
          }); 
          if(columnsObj.storageName) localStorage.setItem(columnsObj.storageName, originMapUrl);
        }
        //End
        if(columnsObj.hasOwnProperty("showDetails")){    
          localStorage.setItem("fieldSetValsource", data.OBLINE_SHIPFROM_COUNTRY)   
          localStorage.setItem("fieldSetValdest", data.OBLINE_SHIPTO_COUNTRY)
          if (columnsObj.configName =='destination' &&  columnsObj?.showDetails?.find(e => e.event === "VALIDATE_WHEN_AUTOCOMPLETE_SELECTED")) {
           this.appService._components[columnsObj.configName].onCommonEventHander('VALIDATE_WHEN_AUTOCOMPLETE_SELECTED', this.configData?.events)
          }       
        }
      });
    }

    if (data.ORDER_BASE_LINE_XID) {

      this.frmGroup.get(this.configData.name + "Id1").setValue(data.ORDER_BASE_LINE_XID);
      this.frmGroup.get(this.configData.name + "Id2").setValue(data.ORDER_BASE_XID);
      this.frmGroup.get(this.configData.name + "Id3").setValue(data.ITEM_XID);
    }

    if (data.OBLINE_SHIPFROM_ID) {
      localStorage.setItem('poSourceId', data.OBLINE_SHIPFROM_ID);
    }
    if (data.OBLINE_SHIPTO_ID) {
      localStorage.setItem('poDestId', data.OBLINE_SHIPTO_ID);
    }
    if (data.REQ_DELV_DATE) {
      localStorage.setItem('poDeliveryDate', data.REQ_DELV_DATE);
    } else if (data?.REQ_DELV_DATE_LATE) {
      localStorage.setItem('poDeliveryDate', data?.REQ_DELV_DATE_LATE);
    }
    
    if (data.itemId) {
      this.frmGroup.get(this.configData.name + "Id").setValue(data.itemId);
    }
    this.frmGroup.get(this.configData.name).setValue(data.primaryValue);
    this.suggestionList = [];
  }

  locationDateSave = (selectedPoLines, fieldName) =>{
    if (selectedPoLines) {
      let locationObj;
      if (fieldName == "destination") {
        locationObj = {
          locationId: selectedPoLines['OBLINE_SHIPTO_ID'],
          locationName: selectedPoLines['OBLINE_SHIPTO_NAME'],
          addressLine: selectedPoLines['OBLINE_SHIPTO_ADDRESS_LINE_1'],
          city: selectedPoLines['OBLINE_SHIPTO_CITY'],
          postalCode: selectedPoLines['OBLINE_SHIPTO_POSTALCODE'],
          countryCode: selectedPoLines['OBLINE_SHIPTO_COUNTRY'],
          latitude: selectedPoLines['OBLINE_SHIPTO_LAT'],
          longitude: selectedPoLines['OBLINE_SHIPTO_LON'],
          provinceCode: selectedPoLines['OBLINE_SHIPTO_PROVINCECODE'],
          domainName: selectedPoLines[''],
          contactXid: selectedPoLines['']
        };
      } else if (fieldName == "source") {
        locationObj = {
          locationId: selectedPoLines['OBLINE_SHIPFROM_ID'],
          locationName: selectedPoLines['OBLINE_SHIPFROM_NAME'],
          addressLine: selectedPoLines['OBLINE_SHIPFROM_ADDRESS_LINE_1'],
          city: selectedPoLines['OBLINE_SHIPFROM_CITY'],
          postalCode: selectedPoLines['OBLINE_SHIPFROM_POSTALCODE'],
          countryCode: selectedPoLines['OBLINE_SHIPFROM_COUNTRY'],
          latitude: selectedPoLines['OBLINE_SHIPFROM_LAT'],
          longitude: selectedPoLines['OBLINE_SHIPFROM_LON'],
          provinceCode: selectedPoLines['OBLINE_SHIPFROM_PROVINCECODE'],
          domainName: selectedPoLines[''],
          contactXid: selectedPoLines['']
        };
      } else if (fieldName == "origin") {
        locationObj = {
          locationId: selectedPoLines['OBLINE_SHIPFROM_ID'],
          locationName: selectedPoLines['OBLINE_SHIPFROM_NAME'],
          addressLine: selectedPoLines['OBLINE_SHIPFROM_ADDRESS_LINE_1'],
          city: selectedPoLines['OBLINE_SHIPFROM_CITY'],
          postalCode: selectedPoLines['OBLINE_SHIPFROM_POSTALCODE'],
          countryCode: selectedPoLines['OBLINE_SHIPFROM_COUNTRY'],
          latitude: selectedPoLines['OBLINE_SHIPFROM_LAT'],
          longitude: selectedPoLines['OBLINE_SHIPFROM_LON'],
          provinceCode: selectedPoLines['OBLINE_SHIPFROM_PROVINCECODE'],
          domainName: selectedPoLines[''],
          contactXid: selectedPoLines['']
        };
      }
      let localStorageLocation = localStorage.getItem("selectedLocation");
      let selectedLocation = localStorageLocation ? JSON.parse(localStorageLocation) : {};
      selectedLocation[fieldName] = locationObj;
      let storeObj = JSON.stringify(selectedLocation);
      localStorage.setItem("selectedLocation", storeObj);
    } else {
      localStorage.removeItem("selectedLocation");
    }
    //End
  }
  makeapicall(searchText) {
    console.log(this.frmGroup.get(this.configData.name).errors)
    let poSourceId = localStorage.getItem('poSourceId');
    let poDestId = localStorage.getItem('poDestId');
    let poDeliveryDate = localStorage.getItem('poDeliveryDate');
  
    let isPoDeliveryDate = true;
    this.progressBar = true;
    let url = '';
    if (this.configData['url']) {
      let poLines = '';
      // let exclude = JSON.parse(localStorage.getItem('poLineIdToBeExcluded'));
      let id = this.frmGroup.parent.value.indexOf(this.frmGroup.value);
      this.frmGroup.parent.value.forEach((line, idx) => {
        if (idx != id) {
          console.log(line.poLineItem);
          if (line.poLineItemId1) {
            poLines += line.poLineItemId1;
            if (!(this.frmGroup.parent.value.length - 1 == idx)) {
              poLines += ',';
            }
          }
        }
      })
      let lastChar = poLines.slice(-1);
      if (lastChar == ',') {
        poLines = poLines.slice(0, -1);
      }

      //slice used to take deep copy
      let formVals = this.frmGroup.parent.value.slice().splice(id, 1);
      formVals.map((val) => { if (val.poLineItemId1) { return val.poLineItemId1 } }).join(',');
      // poLines = formVals.join(',');

      url = this.configData['url'] + localStorage.getItem('customerCode') +
        '&userId=' + localStorage.getItem('userName') +
        "&searchString=" + searchText.toUpperCase() + '&poLineToBeExluded=' + poLines;
    } else {
      url = APP_Constants.ITEM_SEARCH_URL + localStorage.getItem('customerCode') +
        '&userId=' + localStorage.getItem('userName') +
        "&searchString=" + searchText.toUpperCase();
    }
    this.appService.makeHttpGetRequest(url)
      .subscribe(data => {
        this.progressBar = false;
        if (data['message'].statusCode === APP_Constants.SUCCESS_CODE) {
          if (this.configData['responseData']) {
            this.suggestionList = data[this.configData['responseData']];
            this.suggestionList.map(item => {
              this.frmGroup.get(this.configData.name)['itemArray'].push(item[this.configData['primaryText'][0]] + ' -- ' + item[this.configData['primaryText'][1]]);
              item['primaryValue'] = item[this.configData['primaryText'][0]] + ' -- ' + item[this.configData['primaryText'][1]];
              if (poSourceId && poDestId) {
                let reqDelDate1;
                let reqDelDate2;
                if(this.configData['isPoDeliveryDate']){
                  if(item?.REQ_DELV_DATE){ 
                    reqDelDate1=moment(item?.REQ_DELV_DATE);
                    reqDelDate2=moment(poDeliveryDate);
                    isPoDeliveryDate=reqDelDate1.format("YYYY-MM-DD") === reqDelDate2.format("YYYY-MM-DD");
                  }
                  else if(item?.REQ_DELV_DATE_LATE){ 
                    reqDelDate1=moment(item?.REQ_DELV_DATE_LATE);
                    reqDelDate2=moment(poDeliveryDate);
                    isPoDeliveryDate=reqDelDate1.format("YYYY-MM-DD") === reqDelDate2.format("YYYY-MM-DD");
                  } else {
                    isPoDeliveryDate = false;
                  }
                }
                if (item.OBLINE_SHIPTO_ID === poDestId && item.OBLINE_SHIPFROM_ID === poSourceId && isPoDeliveryDate) {
                  if(this.configData?.excludedStatus?.indexOf(item.OB_STATUS_TYPE) > -1){
                   item['disable'] = true;
                  } else{
                    item['disable'] = false;
                  }
                } else {
                  item['disable'] = true;
                }
              } else {
                if(this.configData?.excludedStatus?.indexOf(item.OB_STATUS_TYPE) > -1){
                  item['disable'] = true;
                } else{
                item['disable'] = false;
              }
            }
            if (this.configData['disablePORole'] ==  localStorage.getItem('userRole')) {
              item['disable'] = false;
            } 
            if ((item.OBLINE_SHIPTO_ID === poDestId && item.OBLINE_SHIPFROM_ID === poSourceId && this.configData['isPolocation'])&& !(this.configData['isPoDeliveryDate'])) {
              item['disable'] = false;
            }
            if(item.OB_LINE_STATUS_VALUE_XID && item.OB_LINE_STATUS_VALUE_XID.toUpperCase() === 'OVER RELEASED'){
              item['disable'] = true;
            }
            if (item.OBLINE_SHIPTO_ID === poDestId && item.OBLINE_SHIPFROM_ID === poSourceId && this.configData['isPolocation'] &&  this.configData?.excludedStatus?.indexOf(item.OB_STATUS_TYPE) > -1) {          
              item['disable'] = true;
            }
          })
        } else {
            this.suggestionList = data['items'];
            console.log('suggestionList', this.suggestionList)
            this.suggestionList.map((item) => {
              this.frmGroup.get(this.configData.name)['itemArray'].push(item.itemId + ' - ' + item.itemName);
            })
          }
        } else {
          this.suggestionList = [];
          this.frmGroup.get(this.configData.name)['itemArray'] = [];
          this.noItemFound = true;
          this.configData.validation.forEach(elem => {
            if (elem === 'SelectFromList') {
              this.frmGroup.get(this.configData.name).setErrors({ 'NoItemFound': { 'message': '' } });
            }
          });
        }
      },
        (err) => {
          this.progressBar = false;
          let modal = new Modal({
            action: false, name: 'itemSearch', title: 'Item Search', description: err.message, actionButtonText: ''
          });
          this.modalService.createModalBox(modal, err.status);
          // console.log(err)
        }
      );
  }

  close() {
    this.searchStr = "";
    this.frmGroup.get(this.configData.name).setValue(this.searchStr);
    this.typing = false;
    this.renderer.removeAttribute(this.inputEle.nativeElement, 'placeholder');
    this.renderer.removeClass(this.inputEle.nativeElement.parentElement, 'active');
  }
}